import { useEffect, useMemo, useState } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import WalletIcon from '@mui/icons-material/Wallet';
import SchemaIcon from '@mui/icons-material/Schema';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import { blue } from '@mui/material/colors';
import { useSelector } from 'react-redux';
import './style.css';
import MetaMaskIcon from '../../../components/MetaMaskIcon';
import EthereumIcon from '../../../components/EthereumIcon';
import { styled } from '@mui/material/styles';
import pkg from '../../../../package.json';
import { AboutIcon } from '../../../util/icons';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import IconButton from '@mui/material/IconButton';
import Page from '../../../components/Page';
import PageTitle from '../../../components/PageTitle';
import { VALID_DOMAINS } from '../../../components/ManageEvidence/config';
import InventoryIcon from '@mui/icons-material/Inventory';
import { Link as LinkTo } from 'react-router-dom';
import { PATH_OFFERS } from '../../config';
import { IS_IOS, LINK_APP_STORE, LINK_GOOGLE_PLAY } from '../../../components/AppInstructions/config';


const Copyright = styled( Typography )(({ theme }) => ({
    ...theme.typography.body2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    height: 40,
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

const menuItems = [ 'whatIsThis', 'howdPublish', 'trades', 'whyDo', 'whyArchives', 'whyImage' ];

const About = () => {

    const labels = useMemo(() => new LocalizedStrings( LOCALIZATIONS ), []),
    locale = useSelector( state => state.app.locale ),
    theme = useTheme(),
    isMobile = useMediaQuery( theme.breakpoints.down('md') ),
    [ open, setOpen ] = useState( false );

    /**
     * @name handleChange
     * @function
     * @description Handles the mobile menu change
     * @param {EventListenerObject} event 
     * @param {number} value 
     */
    const handleChange = ( event, value ) => {
        switch( value ){
            case 0:
                setOpen( true );
                break;
            case 1:
                navigate( 'top' )();
                break;
            default:
                break;
        }
    }

    /**
     * @name navigate
     * @function
     * @description
     * @param {string} hash 
     * @returns {function}
     */
    const navigate = hash => () => {
        window.location.hash = "#" + hash;
        setOpen( false );
    }

    /**
     * @name toggleMenu
     * @function
     * @description Closes the menu
     */
    const toggleMenu = () => {
        setOpen( false );
    }

    // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale )
    }, [ labels, locale ]);

    return (
        <>
            <Page modifier="about" title={ labels.about }>
                <Grid container>
                    {
                        !isMobile ? 
                            <Grid item xs={ 3 }>
                                <div className="coe__about__menu">
                                    <Paper elevation={ 3 }>
                                        <MenuList>
                                            {
                                                menuItems.map(
                                                    item => (
                                                        <MenuItem key={ 'about-desktop-' + item } onClick={ navigate( item ) }>
                                                            { labels[ item ] }
                                                        </MenuItem>
                                                    )
                                                )
                                            }
                                        </MenuList>
                                    </Paper>
                                    <Button aria-label={ labels.backToTop } href="#top" startIcon={ <ArrowCircleUpIcon /> }>
                                        { labels.backToTop }
                                    </Button>
                                </div>
                            </Grid> :
                            null
                    }
                    
                    <Grid item className="coe__about__body" md={ 9 } xs={ 12 }>
                        
                        <div className="coe__about__version">
                            <Chip 
                                color="primary"
                                label={  pkg.version } />
                        </div>

                        <PageTitle Icon={ AboutIcon } title={ labels.about } />
                        
                        <Typography variant="h2" id="whatIsThis">{ labels.whatIsThis }</Typography>
                        <Typography>
                            { 
                                labels.formatString( 
                                    labels.p1, 
                                    <Link href="https://ethereum.org/en/" target="_blank">{ labels.ethereum }</Link> 
                                ) 
                            }
                        </Typography>
                        <Typography>{ labels.p2 }</Typography>
                        <Alert severity="warning">
                            <AlertTitle>{ labels.alert1Quote }</AlertTitle>
                            { labels.alert1 }
                        </Alert>
                        <Typography variant="h2" id="howdPublish">{ labels.howdPublish }</Typography>
                        <List disablePadding>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar sx={{ bgcolor: blue[ 500 ] }}>
                                        <MetaMaskIcon className="coe__about__mm" />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText 
                                    primary={ labels.installMetamask }
                                    secondary={ 

                                        !isMobile ?
                                            labels.formatString( 
                                                labels.how1,
                                                labels.installMetamask
                                            ) :
                                            labels.formatString( 
                                                labels.how1Mobile,
                                                <Link href={ IS_IOS ? LINK_APP_STORE : LINK_GOOGLE_PLAY }>{ labels.mobileInstall }</Link>
                                            )
                                    } />
                            </ListItem>
                            {
                                isMobile ?
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar sx={{ bgcolor: blue[ 500 ] }}>
                                                <SchemaIcon />
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText 
                                            primary={ labels.metaMaskBrowser }
                                            secondary={ labels.how1_5Mobile } />
                                    </ListItem> :
                                    null
                            }
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar sx={{ bgcolor: blue[ 500 ] }}>
                                        <SchemaIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText 
                                    primary={ labels.makeBoard }
                                    secondary={ labels.how3 } />
                            </ListItem>
                            { 
                                !isMobile ? 
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar sx={{ bgcolor: blue[ 500 ] }}>
                                                <WalletIcon />
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText 
                                            primary={ labels.connectWallet }
                                            secondary={ 
                                                labels.formatString( 
                                                    labels.how2, 
                                                    labels.connectToMetaMask
                                                ) 
                                            } />
                                    </ListItem> :
                                    null
                            }
                            
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar sx={{ bgcolor: blue[ 500 ] }}>
                                        <EthereumIcon className="coe__about__eth"  />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText 
                                    primary={ labels.mint }
                                    secondary={ labels.formatString( labels.how4, labels.mintToBlockchain ) } />
                            </ListItem>
                        </List>
                        <Typography variant="h2" id="trades">{ labels.trades }</Typography>
                        <Typography>{ labels.tradesP1 }</Typography>
                        <Typography>
                            { 
                                labels.formatString(
                                    labels.tradesP2,
                                    <Link component={ LinkTo } to={ PATH_OFFERS }>{ labels.offers }</Link>
                                )
                            }
                        </Typography>
                        <Typography>{ labels.tradesP3 }</Typography>
                        <Typography variant="h2" id="whyDo">{ labels.whyDo }</Typography>
                        <Typography>{ labels.whyDoP1 }</Typography>
                        <Typography>{ labels.whyDoP2 }</Typography>
                        <Typography variant="h2" id="whyDo">{ labels.whyArchives }</Typography>
                        <Typography> { labels.whyArchivesP1 }</Typography>
                        <List>
                            {
                                VALID_DOMAINS.map(
                                    domain => (
                                        <ListItem key={ domain }>
                                            <ListItemAvatar>
                                                <Avatar sx={{ bgcolor: blue[ 500 ] }}>
                                                    <InventoryIcon />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText>
                                                <Link href={ `https://${ domain }` } target="_blank">{ domain }</Link>
                                                 
                                            </ListItemText>
                                        </ListItem>
                                    )
                                )
                            }
                        </List>
                        <Typography>{ labels.whyArchivesP2 }</Typography>
                        <Typography variant="h2" id="whyImage">{ labels.whyImage }</Typography>
                        <Typography>{ labels.whyImageP1 }</Typography>
                        <Typography>{ labels.whyImageP2 }</Typography>
                        <Copyright>{ labels.copyright }</Copyright>
                    </Grid>
                </Grid>
            </Page>
            {
                isMobile ?
                    <>
                        <Paper sx={{ position: 'sticky', bottom: 0, left: 0, right: 0 }} elevation={ 3 }>
                            <BottomNavigation showLabels value="Menu" onChange={ handleChange }>
                                <BottomNavigationAction label={ labels.menu } icon={ <MoreHorizIcon />} />
                                <BottomNavigationAction label={ labels.backToTop } icon={ <ArrowCircleUpIcon /> } />
                            </BottomNavigation>
                        </Paper>
                        <Drawer
                            anchor="left"
                            className="coe__about__drawer"
                            open={ open }
                            onClose={ toggleMenu }>
                            <DrawerHeader>
                                <IconButton onClick={ toggleMenu } aria-label="close">
                                    <ArrowBackIosNewIcon />
                                </IconButton>
                            </DrawerHeader>
                            <Divider />
                            <List>
                                {
                                    menuItems.map(
                                        item => (
                                            <ListItem key={ 'about-mobile-' + item } disablePadding>
                                                <ListItemButton  onClick={ navigate( item ) } aria-label={ labels[ item ] }>
                                                    <ListItemText primary={ labels[ item ] } />
                                                </ListItemButton>
                                            </ListItem>
                                        )
                                    )
                                }
                            </List>
                        </Drawer>
                    </> :
                    null
            }
        </>
    )

}

export default About;